
/*
 * renders when the collection has items. Can be used
 * on with virtual elements.
 * @param anyArray any array observable or not
 * @example <!-- ko any: collection -->content<!-- /ko -->
 */
ko.bindingHandlers.any = {
  init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
    return ko.bindingHandlers['if']['init'](element, (function() {
      return ko.computed(function() {
        return helpers.hasItems(valueAccessor());
      });
    }), allBindings, viewModel, bindingContext);
  }
};

ko.virtualElements.allowedBindings.any = true;
